<template>
      <a-col>
        <div type="flex" justify="center" align="center" class="agree_checkbox">
          <a-checkbox @change="switchCheckedState" :class="currentBg">同意服務條款內容</a-checkbox>
        </div>
        <div>
            <a-button block class="step_btn" size="large" :class="currentBg" :disabled="isDisabled" @click="pushToNextStep">下一步</a-button>
        </div>
      </a-col>
</template>

<script>
    export default {
        data() {
            return {
                isDisabled: true,
            }
        },
        methods: {
            switchCheckedState(e) {
                this.isDisabled = !e.target.checked;
            },
            pushToNextStep() {
                this.$router.push(`/provisioning/step2`);
            }
        },     
        computed: {
            currentBg: function() {
                const bg =  !this.isDisabled ? 'green_bg' : '';
                return bg;
            },
        },
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global.scss";


</style>